import { SortOptions } from '~src/ts/models/sort/CommonSortOptions';
import { OptionsDictionary } from '~src/ts/models/sort/SortOptionDefinitions';

export const mixedContentOptions: OptionsDictionary = {
  // Mixed Content does not support relevance
  'name': SortOptions.name,
  'type': SortOptions.type,
  'owner': SortOptions.mixedContentOwner,
  'updated': SortOptions.updated
};
